"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const v4_1 = require("zod/v4");
exports.TaskSchema = tape_sanitizer_1.JoinTransformationSchema.omit({
    srcDataTape: true,
    joinDataTape: true,
}).extend({
    operation: v4_1.z.literal('join'),
    srcArtifactSlug: v4_1.z.string(),
    joinArtifactSlug: v4_1.z.string(),
});
exports.UiConfigSchema = exports.TaskSchema;
exports.nodeType = 'operation_join';
//# sourceMappingURL=types.js.map